export const FileFields = {
    metadata: "metadata",
    pkCode: "pkCode",
    parentId: "parentId",
    category: "category",
    file: "file"
}